import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { DialogRef } from '../dialog-ref';
import { DialogCloseable } from '../dialog-closeable';

@Component({
    selector: 'ihd-dialog-confirm',
    styleUrls: ['./dialog-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './dialog-confirm.component.html',
    host: {
        class: 'c-dialog active confirm c-dialog--gutter-xlg',
        '[class.c-dialog--icon]': 'config?.icon && config?.icon.length > 0',
        '[class.c-dialog--sm]': 'config?.small',
        '[class.c-dialog--lg]': '!config?.small',
    },
})
export class DialogConfirmComponent implements DialogCloseable {
    public config;
    public confirmText: string;
    public cancelText: string;
    public optionalMessage: string;
    public confirmBtnModifierClass: string;
    public isClosing: boolean = false;

    constructor(
        public dialogRef: DialogRef<DialogConfirmComponent>,
        public cdr: ChangeDetectorRef
    ) {
        if (dialogRef.containerInstance && dialogRef.containerInstance.config) {
            this.config = dialogRef.containerInstance.config;
            this.confirmText = this.config.confirmText || 'Common.Confirm';
            this.cancelText = this.config.cancelText || 'Common.Cancel';
            this.confirmBtnModifierClass =
                this.config.confirmBtnModifierClass || 'c-btn--primary';

            if (
                this.config.optionalMessage &&
                this.config.optionalMessageText
            ) {
                this.optionalMessage = this.config.optionalMessageText;
            }
        } else {
            this.config = {
                icon: [],
            };
        }
    }

    /**
     * Updates the closing status.
     */
    onClose() {
        this.isClosing = true;
        this.cdr.detectChanges();
    }
}
